import { DecimalPipe } from '@angular/common';
import { Directive, DoCheck, ElementRef, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormControl } from '@angular/forms';
import { AppConstant } from '@app/@core/constants/app-constant';

@Directive({
    selector: '[ngxAppValidationMessageFor]',
    standalone: false
})
export class ValidationMessageDirective implements OnInit, DoCheck {
    @Input('ngxAppValidationMessageFor') appValidationMessageFor: FormControl;
    formSubmitAttempt: boolean;

    constructor(
        private controlContainer: ControlContainer,
        private elementRef: ElementRef) { }

    ngOnInit() {
        this.elementRef.nativeElement.style.display = 'none';
        (<FormGroupDirective>this.controlContainer.formDirective).ngSubmit.subscribe(() => {
            this.formSubmitAttempt = true;
        });
    }

    ngDoCheck() {
        if (this.appValidationMessageFor.invalid && (this.formSubmitAttempt || this.appValidationMessageFor.touched)) {
            this.elementRef.nativeElement.innerHTML = '';
            this.appValidationMessageFor.markAsTouched();
            Object.keys(this.appValidationMessageFor.errors).forEach(keyError => {
                this.elementRef.nativeElement.innerHTML = this.getErrorMessage(keyError);
                this.elementRef.nativeElement.style.display = 'inline-block';
            });
        } else {
            this.elementRef.nativeElement.style.display = 'none';
        }
    }

    getErrorMessage(keyError) {
      switch (keyError) {
        case 'required':
          return 'This field is required.';
        case 'pattern':
          return 'This field is not valid.';
        case 'minlength':
          return `This field must be ${this.appValidationMessageFor.errors[keyError].requiredLength} characters.`;
        case 'maxlength':
          return `This field must be a maximum of ${this.appValidationMessageFor.errors[keyError].requiredLength} characters.`;
        case 'min':
          return `Must be greater or equal to ${new DecimalPipe('en-us').transform(this.appValidationMessageFor.errors[keyError].min)}.`;
        case 'max':
          return `Must be lesser or equal to ${new DecimalPipe('en-us').transform(this.appValidationMessageFor.errors[keyError].max)}.`
        case 'custom':
          return this.appValidationMessageFor.errors[keyError];
        case 'deliveryContactTheSame':
          return 'Primary Delivery Contact and Secondary Deliver Contact must be different.'
      }

      switch (typeof this.appValidationMessageFor.errors[keyError]) {
        case 'string':
          return <string>this.appValidationMessageFor.errors[keyError];
        default:
          if (keyError.indexOf('nbDatepicker') > -1) {
            return `Validation failed: Invalid date time format`;
          }
          if (keyError === 'email') {
            return 'Invalid email format.';
          }
          return `Validation failed: ${keyError}`;
      }
  }
}
